'use client';

import { useState, useEffect } from 'react';

/** Returns true after the component has mounted on the client. Use to defer rendering of components that require DOM dimensions (e.g. recharts ResponsiveContainer). */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
